/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { RoutingSolutionVoModel } from './routing-solution-vo.model';
import { CurrencyValueModel } from './currency-value.model';

export class SolutionSegmentSelectedRsDtoModel extends JSONable {

  uuid: string | undefined = undefined;

  routingSolutionVo: RoutingSolutionVoModel | undefined = undefined;

  segmentUuid: string | undefined = undefined;

  masterRoutingSolutionUuid: string | undefined = undefined;

  cost: CurrencyValueModel | undefined = undefined;

  hasTasks: boolean | undefined = undefined;

  hasOrder: boolean | undefined = undefined;
}
